export type DateInput = Date | string | null | undefined;

export function toDateValue(value: DateInput): Date | null {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }

  const match = /^(\d{4})-(\d{2})(?:-(\d{2}))?/.exec(value);
  const date = match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3] || '1'))
    : new Date(value);

  return isNaN(date.getTime()) ? null : date;
}

export function toIsoDate(value: DateInput): string | null {
  const date = toDateValue(value);
  if (!date) {
    return null;
  }

  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export function toIsoMonthStartDate(value: DateInput): string | null {
  const date = toDateValue(value);
  if (!date) {
    return null;
  }

  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  return `${date.getFullYear()}-${month}-01`;
}

export function defaultDatepickerDate(): Date {
  const now = new Date();
  return new Date(now.getFullYear(), 0, 1);
}

export function currentMonthDatepickerDate(): Date {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
}
